<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("country", 2) }}
      </div>
      <router-link class="btn-blue" to="countries"
        >{{ $tc("country", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- CINEMAS SELECTION -->
          <div
            v-for="(item, index) in Countries"
            :key="index"
            v-if="item.fieldname !== 'country_id'"
            class="col-lg-6 col-xl-4 mb-4 align-self-center"
          >
            <div v-if="item.fieldname !== 'country_is_active'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    @focus="onFocusHandler"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                    placeholder="."
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  />
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has(item.fieldname)">{{
                  errors.first(`${item.fieldname}`)
                }}</span>
              </p>
            </div>
            <div
              v-if="item.fieldname === 'country_is_active'"
              class="d-flex align-items-center"
            >
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span> 
              </label>-->
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="onFinalSubmit(true)"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="onResetForm()" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="countries"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Countries from "@/helper/formJSONMaster/Countries";

export default {
  data() {
    return {
      btenable: false,
      Countries: Countries.ms_countries,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Countries.Methods,
    };
  },
  beforeMount() {
    this.onResetForm();
  },
  mounted() {
    console.log("Countries :", Countries);
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onResetForm: function () {
      this.Countries.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody("POST", this.Countries, this.Methods);
          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/countries",
                  });
                }
              } else {
                // Show Error Message:
                this.$toasted.show(data.message);
                console.log("data.message :", data.message);
              }
            })
            .catch((error) => {
              // Catch Error:
              console.log("Catch Error On AddDenomination :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CountriesComponents/addCountry.vue